import './bootstrap';

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/userStore'
import router from './pubRouter';
import App from './PubApp.vue'

const pinia = createPinia()
import i18n from './langSetup'

const app = createApp(App)
.use(i18n)
.use(pinia)
.use(router)

router.isReady().then(() => {
  app.mount('#app')
});
